import ContactSupport from 'features/reactivation/screens/ContactSupport/ContactSupport';
import React from 'react';

export default function ContactSupportPage() {
  return <ContactSupport />;
}
